import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Form, Button, Spin, DatePicker } from "antd";

import {
  MISSATGE_CAMP_OBLIGATORI,
  MISSATGE_ALTA_OBSERVADOR_ERROR,
  MISSATGE_ALTA_OBSERVADOR_OK,
  MISSATGE_ALTA_OBSERVADOR_TITOL,
  MISSATGE_SPIN_ALTA_OBSERVADOR,
  TITOL_ALTA_OBSERVADOR
} from "../../constantsFormularis";
import styles from "./ObservadorFormulariDonarAlta.module.css";
import { NotificacioExit } from "../Notification";
import { fetchDonarAltaObservador } from "../../actions/consultesServidor";
import { getDadesObservador } from "../../reducers";
import { setTitolApartat, errorConsultaServidor } from "../../actions";
import { MASCARA_DDMMYYYY, convertirTextAMomentLocal } from "../../utils/dates";
import { rutaDetallObservador } from "../../routes";

class ObservadorFormulariDonarAlta extends Component {
  state = {
    canviEnCurs: false
  };

  componentDidMount() {
    this.props.setTitolApartat(TITOL_ALTA_OBSERVADOR);
  }

  setCanviEnCurs = value => {
    this.setState({ canviEnCurs: value });
  };

  getNomObservador = observador => {
    if (!observador) {
      return "";
    }

    const nomObservador = `${observador.nom
      ? observador.nom
      : ""} ${observador.cognom1 ? observador.cognom1 : ""} ${observador.cognom2
      ? observador.cognom2
      : ""}`;
    return nomObservador;
  };

  handleCanvi = e => {
    e.preventDefault();
    const { form, dadesObservador, history } = this.props;
    const idObservador = dadesObservador.key;
    const usuari = dadesObservador.usuariNom;

    this.setCanviEnCurs(true);

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const dataSeleccionada = convertirTextAMomentLocal(
          values.dataSeleccionada
        ).format(MASCARA_DDMMYYYY);

        fetchDonarAltaObservador(idObservador, dataSeleccionada, usuari).then(
          dadesResultat => {
            form.resetFields();
            this.setCanviEnCurs(false);
            dadesResultat && dadesResultat.message
              ? this.props.errorConsultaServidor(
                  dadesResultat.titol,
                  dadesResultat.message
                )
              : dadesResultat
                ? NotificacioExit(
                    MISSATGE_ALTA_OBSERVADOR_TITOL,
                    MISSATGE_ALTA_OBSERVADOR_OK
                  )
                : this.props.errorConsultaServidor(
                    MISSATGE_ALTA_OBSERVADOR_TITOL,
                    MISSATGE_ALTA_OBSERVADOR_ERROR
                  );
            history.push({
              pathname: rutaDetallObservador
            });
          },
          error => {
            this.setCanviEnCurs(false);
            this.props.errorConsultaServidor(
              error,
              error.titol ? error.titol : MISSATGE_ALTA_OBSERVADOR_ERROR
            );
          }
        );
      }

      this.setCanviEnCurs(false);
    });
  };

  render() {
    const { form, dadesObservador } = this.props;
    const { getFieldDecorator } = form;
    const nomObservador = this.getNomObservador(dadesObservador);

    return (
      <Spin
        spinning={this.state.canviEnCurs}
        tip={MISSATGE_SPIN_ALTA_OBSERVADOR}
        delay={0}
      >
        <div>
          <div className={styles.alta_form}>
            <span className={styles.campTitol}>{"Observador: "}</span>
            {nomObservador}
            <Form layout="vertical" onSubmit={this.handleCanvi}>
              <Form.Item
                label="Seleccionar la data d'alta"
                className={styles.label}
              >
                {getFieldDecorator("dataSeleccionada", {
                  rules: [
                    {
                      type: "object",
                      required: true,
                      message: MISSATGE_CAMP_OBLIGATORI
                    }
                  ]
                })(
                  <DatePicker
                    placeholder="Seleccionar data"
                    format={MASCARA_DDMMYYYY}
                  />
                )}
              </Form.Item>

              <Link
                className={styles.botoTornar}
                to={{
                  pathname: rutaDetallObservador,
                  query: { render: false }
                }}
              >
                <Button icon="left">Tornar</Button>
              </Link>

              <Button type="primary" htmlType="submit">
                Guardar
              </Button>

              <Form.Item />
            </Form>
          </div>
        </div>
      </Spin>
    );
  }
}

ObservadorFormulariDonarAlta.propTypes = {
  dadesObservador: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    dadesObservador: getDadesObservador(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor
};

const WrappedNormalAltaForm = Form.create({ name: "alta_observador" })(
  ObservadorFormulariDonarAlta
);

export default connect(mapStateToProps, mapDispatchToProps)(
  WrappedNormalAltaForm
);
